<template>
    <div style="background-color: #ffffff;min-height: 100vh;overflow-y: scroll;">
        <nav-bar class="title_top" :icon="'img/backb.png'" :textColor="'#111'" :backColor="'none'" />
        <div class="input_content">
            <div class="input_box">
                <input v-model="exchangeMoney" class="input_item" type="number" placeholder="请输入兑换收益">
                <div class="money">{{ '收益余额：' + money }}</div>
            </div>
        </div>
        <div class="input_content">
            <div class="input_box_">
                <div class="money_"><img class="gold_icon" src="img/bi.png" alt="">{{ '金币余额：' + diamonds }}</div>
            </div>
        </div>
        <div class="money_tips">*收益可兑换成金币，兑换比例：1收益=10金币，兑换的收益必须为整数。</div>
        <div class="btn_box_">
            <div class="btn_item" @click="withdrawAct">确认兑换</div>
        </div>
        <div class="mask" v-if="showPasswordModal">
            <div class="modal_content" style="background-image:url('img/myIncome/modal_bg.png')">
                <div class="modal_title">密码验证</div>
                <div class="input_item_password_box">
                    <input v-model="password" class="input_item_password" type="number" placeholder="请输入二级安全密码">
                </div>
                <div class="btns_box">
                    <div class="btn_item_cancel" @click="showPasswordModal = false">取消</div>
                    <div class="btn_item_enter" @click="confirm">确定</div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import "@/assets/css/base.css";
import "@/assets/css/index.css";
import NavBar from "@/components/navBar.vue";
import { userWallet, moduleDisplay, walletIndex, applyExchange } from "@/api/wallet";
export default {
    components: {
        NavBar,
    },
    data() {
        return {
            walletInfo: {},
            money: '',
            password: '',
            moduleData: {},
            diamonds:'',
            exchangeMoney: '',
            showPasswordModal: false
        }
    },
    created() {
        this.getWalletIndex()
        this.getUserWallet()
        this.moduleDisplay()
    },
    methods: {
        getWalletIndex() {
            walletIndex({}).then((res) => {
                console.log(res);
                this.walletInfo = res.data.account_list[1]
            });
        },
        getUserWallet() {
            userWallet({})
                .then(
                    (response) => {
                        this.money = response.data.money;
                        this.diamonds = response.data.diamonds; 
                    },
                    (error) => {
                        console.log(error);
                        this.$toast.fail(error);
                    }
                )
                .catch((error) => {
                    this.$toast.fail(error);
                });
        },
        moduleDisplay() {
            moduleDisplay({}).then((res) => {
                this.moduleData = res.data;
            });
        },
        doExchange() {
            let params = {
                money: this.exchangeMoney,
                password: this.password,
            }
            applyExchange(params).then(
                (response) => {
                    console.log(response)
                    this.$toast.success('兑换成功');
                    this.password = ''
                    this.exchangeMoney = ''
                    this.showPasswordModal = false;
                    this.getUserWallet()
                },
                (error) => {
                    console.log(error)
                    this.$toast.fail(error);
                }
            )
                .catch((error) => {
                    this.$toast.fail(error);
                });
        },
        confirm() {
            if (this.password == '') {
                this.$toast.fail('请输入二级密码');
                return false;
            }
            this.doExchange()
        },
        withdrawAct() {
            // if (!this.walletInfo.cheques_number) {
            //     this.$toast.fail('请先绑定银行卡');
            //     return false;
            // }
            if (this.exchangeMoney == '') {
                this.$toast.fail('请输入兑换收益');
                return false;
            }
            if (parseInt(this.exchangeMoney) > this.money) {
                this.$toast.fail('兑换收益不能大于收益余额');
                return false;
            }  if ((this.exchangeMoney%1)!=0) {
                this.$toast.fail('兑换收益必须为整数');
                return false;
            }

            if (parseInt(this.exchangeMoney) < 1) {
                this.$toast.fail('兑换收益最小为1');
                return false;
            }
            if (this.moduleData.password_verify == 1) {
                this.showPasswordModal = true;
            } else {
                this.doExchange()
            }
            // if(this.password == ''){
            //     this.showPasswordModal = true;
            //     return false;
            // }
            // this.withdrawMoney = this.withdrawMoney.replace(/[^\d]/g, '');
            // if(this.withdrawMoney == ''){
            //     this.$toast.fail('请输入提现金额');
            //     return false;
            // }
            // if(this.withdrawMoney > this.money){
            //     this.$toast.fail('提现金额不能大于余额');
            //     return false;
            // }
            // if(this.password == ''){
            //     this.showPasswordModal = true;
            //     return false;
            // }   

        }
    }
}
</script>
<style scoped>
.card_box {
    height: 108px;
    padding: 0 40px 0 40px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
}

.card {
    width: 108px;
    height: 108px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.card_text {
    flex-grow: 1;
    padding: 0 20px 0 20px;
}

.card_text div {
    line-height: 54px;
    color: #ffffff;
    font-size: 24px;
    letter-spacing: 2px;
}

.input_content {
    padding: 0 40px 0 40px;
}

.input_box {
    padding: 0 40px 0 40px;
    display: flex;
    align-items: center;
    height: 80px;
    border-radius: 30px;
    background-color: rgba(0, 0, 0, .04);
    margin-top: 60px;
}

.input_box_ {
    padding: 0 40px 0 40px;
    display: flex;
    align-items: center;
    height: 80px;
    border-radius: 30px;
    background-color: rgba(255, 255, 255, .04);
    margin-top: 20px;
}
.money_tips{
    padding: 0 40px 0 40px;
    font-size: 22px;
    color: #999999;
    margin-top: 20px;
    line-height: 50px;
}
.input_item {
    border: none;
    display: block;
    height: 100%;
    font-size: 24px;
    background: transparent;
    color: #999999;
}

.money {
    font-size: 24px;
    color: #ffffff;
    text-align: right;
    flex-grow: 1;
}

.money_ {
    font-size: 24px;
    color: #111;
    display: flex;
    align-items: center;
}

.btn_box_ {
    padding: 0 40px 0 40px;
}

.btn_item {
    width: 100%;
    height: 80px;
    background-color: #51D9FF;
    color: #111111;
    line-height: 80px;
    text-align: center;
    font-size: 28px;
    border-radius: 40px;
    margin-top: 60px;
}

.mask {
    background-color: rgba(0, 0, 0, .5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
}

.modal_content {
    width: 640px;
    height: 500px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 540px auto 0;
    overflow: hidden;
    z-index: 999;
}

.modal_title {
    text-align: center;
    font-size: 34px;
    color: #111111;
    margin-top: 40px;
}

.input_item_password_box {
    padding: 0 40px 0 40px;
    height: 108px;
}

.input_item_password {
    border: none;
    display: block;
    height: 100%;
    width: 100%;
    font-size: 30px;
    background: rgba(216, 216, 216, 1);
    color: #111111;
    border-radius: 20px;
    margin-top: 100px;
    text-indent: 40px;
}

.btns_box {
    height: 98px;
    display: flex;
    justify-content: space-between;
    margin-top: 64px;
    padding: 0 40px 0 40px;
}

.btn_item_cancel {
    width: 236px;
    height: 98px;
    color: #111111;
    background-color: #d8d8d8;
    line-height: 98px;
    text-align: center;
    font-size: 30px;
    border-radius: 20px;
}

.btn_item_enter {
    width: 236px;
    height: 98px;
    color: #111111;
    background-color: #51D9FF;
    line-height: 98px;
    text-align: center;
    font-size: 30px;
    border-radius: 20px;
}

.gold_icon {
    width: 40px;
    height: 40px;
    margin-right: 20px;
}
</style>